var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDeveloperSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96863 6.7937C7.80457 6.7937 7.66395 6.72338 7.5702 6.55932C7.42957 6.34838 7.49988 6.0437 7.73426 5.90307L10.1014 4.44995V4.42651L7.73426 2.97338C7.52332 2.83276 7.45301 2.55151 7.5702 2.31713C7.71082 2.1062 7.99207 2.03588 8.22641 2.15307L10.7108 3.69995L10.7577 3.74682C11.1327 4.12182 11.1327 4.75463 10.7577 5.15307L10.7108 5.19995L8.22641 6.74682C8.13271 6.77026 8.03891 6.7937 7.96863 6.7937Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04687 6.79371C2.95312 6.79371 2.88281 6.77027 2.8125 6.7234L0.32812 5.17652L0.28125 5.15308C-0.09375 4.77808 -0.09375 4.14527 0.28125 3.74683L0.32812 3.69996L2.8125 2.15308C3.02343 2.01246 3.32812 2.08277 3.46875 2.31715C3.60937 2.52808 3.53906 2.83277 3.30468 2.9734L0.9375 4.42652V4.44996L3.30468 5.90308C3.51562 6.04371 3.58593 6.32496 3.46875 6.55933C3.375 6.7234 3.21093 6.79371 3.04687 6.79371Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98413 8.90305C3.93726 8.90305 3.86695 8.90305 3.82007 8.87965C3.5857 8.78585 3.46851 8.50465 3.53882 8.27025L6.5857 0.301514C6.67945 0.0671438 6.9607 -0.0500462 7.19507 0.0202638C7.42945 0.114014 7.54663 0.395264 7.47632 0.629644L4.42945 8.59835C4.35913 8.78585 4.17163 8.90305 3.98413 8.90305Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDeveloperSelected);
export default __webpack_public_path__ + "static/media/Menu-Developer-Selected.23ed4429c1825ab6a5641d4724c6b8f7.svg";
export { ForwardRef as ReactComponent };